import {CoreDI, lazyInject, System} from '@gongxigames/framework/core';
import {SlotSettings, SlotSettingsParameters} from '@gongxigames/framework/slot/configs/SlotSettings';
import {CheatAction, ICheatPluginController, ICheatsModule} from '../../CheatModuleInterfaces';

export type SettingAction = {
    id: string;
    apply: (settings: SlotSettings) => void;
    reject: (settings: SlotSettings) => void;
};

export class CheatSettingsController implements ICheatPluginController {
    public static settingsActions: SettingAction[] = [];

    public settingsActions: CheatAction[] = [];

    @lazyInject(CoreDI.Settings)
    protected readonly settings!: SlotSettings;

    @lazyInject(CoreDI.System)
    protected readonly system!: System;

    protected module!: ICheatsModule;

    public static addSettingAction(action: SettingAction): void {
        this.settingsActions.push(action);
    }

    public onChanged: Function = (): void => {};

    public init(module: ICheatsModule): void {
        this.module = module;
        this.module.storage.on('cheatActions', () => this.onChanged(), this);

        CheatSettingsController.settingsActions.forEach(action => {
            this.settingsActions.push({
                id: action.id,
                apply: () => action.apply(this.settings),
                reject: () => action.reject(this.settings)
            });
        });

        this.settingsActions.forEach(({id}) => {
            const key = id as keyof SlotSettingsParameters;

            if (this.settings.has(key) && this.settings.get(key)) {
                this.toggleSettings(id);
            }
        });
    }

    public get selectedSettings(): string[] {
        const {cheatActions} = this.module.storage.data;

        return this.settingsActions
            .filter(settingsAction => cheatActions.find( act => act.id === settingsAction.id))
            .map(({id}) => id);
    }

    public toggleSettings(id: string): void {
        const settingsAction = this.settingsActions.find(action => action.id === id);

        if (settingsAction) {
            if (this.module.storage.data.cheatActions.find(a => a.id === settingsAction.id)) {
                this.module.removeCheatAction(settingsAction);
            } else {
                this.module.addCheatAction(settingsAction);
            }
        }
    }
}
